export default __webpack_public_path__ + "components/page-header/static/icon-user--white-bf056c7630f232da6746a28d35957a84.svg";